import { render } from "./AddCategorieActiviteModal.vue?vue&type=template&id=83bd6dfc&ts=true"
import script from "./AddCategorieActiviteModal.vue?vue&type=script&lang=ts"
export * from "./AddCategorieActiviteModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__